import CloseIcon from "@mui/icons-material/Close"
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material"
import { getAnalytics, logEvent } from "firebase/analytics"
import { FunctionComponent } from "react"
import { FormattedMessage } from "react-intl"
import bKash from "../assets/bkash.webp"
import Dimen from "../Dimen"
import { Product } from "../Enum"

const BKashDialog: FunctionComponent<{
  product: Product
  onClickClose: () => void
  email: String
}> = ({ product, onClickClose, email }) => {
  const analytics = getAnalytics()

  return (
    <div>
      <DialogTitle>
        <FormattedMessage id="dialog.title.bkash" />
      </DialogTitle>
      <DialogContent>
        <div style={{ paddingTop: Dimen.MarginDefault }}>
          {product === Product.AdFree && (
            <>
              <FormattedMessage id="subscription.adfree.bkash" />
              {/* <b>{email.split('@').at(0)?.toUpperCase()}</b> */}
              <br></br>
              <FormattedMessage id="subscription.email" />
            </>
          )}
          {product === Product.Pro && (
            <>
              <FormattedMessage id="subscription.pro.bkash" />
              {/* <b>{email.split("@").at(0)?.toUpperCase()}</b> */}
              <br></br>
              <FormattedMessage id="subscription.email" />
            </>
          )}
          {product === Product.Enterprise && (
            <>
              <FormattedMessage id="subscription.enterprise.bkash" />
              {/* <b>{email.split("@").at(0)?.toUpperCase()}</b> */}
              <FormattedMessage id="subscription.email" />
            </>
          )}
        </div>
        <img alt="বিকাশ পেমেন্ট" src={bKash} width="270" height="370" />
      </DialogContent>

      <DialogActions>
        {/* Commented out non-functioning link */}
        {/* Monthly payment button */}
        {/* <Button
          variant="contained"
          style={{
            background: Color.BKash,
            color: Color.White,
            border: "none",
          }}
          onClick={() => {
            if (product === Product.AdFree) {
              openInNewTab(PaymentLink.AdFree)
              logEvent(analytics, "web_bkash_adfree_opened")
            } else if (product === Product.Pro) {
              openInNewTab(PaymentLink.Pro)
              logEvent(analytics, "web_bkash_pro_opened")
            } else {
              openInNewTab(PaymentLink.Enterprise)
              logEvent(analytics, "web_bkash_enterprise_opened")
            }
          }}
        >
          {product === Product.AdFree && (
            <FormattedMessage id="dialog.button.pay.adfree" />
          )}
          {product === Product.Pro && (
            <FormattedMessage id="dialog.button.pay.pro" />
          )}
          {product === Product.Enterprise && (
            <FormattedMessage id="dialog.button.pay.enterprise" />
          )}
        </Button> */}

        {/* Commented out non-functioning link */}
        {/* Yearly payment button */}
        {/* {product !== Product.AdFree && (
          <Button
            variant="contained"
            style={{
              background: Color.BKash,
              color: Color.White,
              border: "none",
            }}
            onClick={() => {
              if (product === Product.Pro) {
                openInNewTab(PaymentLink.ProYearly)
                logEvent(analytics, "web_bkash_pro_yearly_opened")
              } else {
                openInNewTab(PaymentLink.EnterpriseYearly)
                logEvent(analytics, "web_bkash_enterprise_yearly_opened")
              }
            }}
          >
            {product === Product.Pro && (
              <FormattedMessage id="dialog.button.pay.pro.yearly" />
            )}
            {product === Product.Enterprise && (
              <FormattedMessage id="dialog.button.pay.enterprise.yearly" />
            )}
          </Button>
        )} */}

        {/* Cancel Button */}
        <Button
          variant="contained"
          onClick={() => {
            logEvent(analytics, "web_bkash_dialog_closed")
            onClickClose()
          }}
          startIcon={<CloseIcon />}
        >
          <FormattedMessage id="dialog.button.cancel" />
        </Button>
      </DialogActions>
    </div>
  )
}

export default BKashDialog
